<template>
  <div class="row">
        <div class="col-sm-12" v-if="type=='default'">
          <h2>Set Margin %</h2>
          <h5>Your current default margin is <b>{{default_margin_rate[0].rate}}% </b><a href="javascript:;" @click="$refs['default-margin-rate'].show()">Edit</a></h5>
          <br>
          <h5>Want to change Margin % for single ticker? Please update below.</h5><br>
        </div>
        <div class="col-sm-12" v-if="type=='account'">
          <div class="pull-right form-group">
            <div style="display:flow-root;">
              <a href="javascript:;" class="pull-right" @click="showModal('upload-deal-ticket-out')" v-if="can_access('marketvalue','upload')">Upload Account(s) Margin Rate CSV</a>
            </div> 
          </div>
        </div>
        <div v-if="type=='account'" class="col-sm-3 form-group" :class="{error: validation.hasError('formInput.account_number')}">
          <label>Account Number</label><span class="message">{{ validation.firstError('formInput.account_number') }}</span>
          <vue-bootstrap-typeahead
              ref="account_number"
              :data="customers"
              v-model="formInput.account_number"
              :serializer="customerFormattedDisplay"
              placeholder="Search Account No."
              @hit="setCustomerInfo"
            />
          <!-- <input type="text" placeholder="Enter Account Number Here.." class="form-control" v-model="formInput.account_number"> -->
        </div>  
        <div class="form-group" :class="{error: validation.hasError('tidm'),'col-sm-3':(type=='account'),'col-sm-6':(type!='account')}">
          <label>Ticker (TIDM)</label><span class="message">{{ validation.firstError('tidm') }}</span>
          <vue-bootstrap-typeahead
                ref="tidm"
                :data="instruments"
                v-model="tidm"
                :serializer="InstrumentFormattedDisplay"
                placeholder="Search Ticker"
                @hit="setInstrumentInfo"
              />
          <!--<input type="text" placeholder="Enter TIDM Here.." class="form-control" v-model="formInput.tidm">-->
        </div>
        <div class="form-group" :class="{error: validation.hasError('formInput.rate'),'col-sm-3':(type=='account'),'col-sm-6':(type!='account')}">
          <label>Margin Rate</label><span class="message">{{ validation.firstError('formInput.rate') }}</span>
          <input type="text" placeholder="Enter Margin Rate Here.." class="form-control" v-model="formInput.rate">
        </div>

        <div v-if="type=='account'" class="col-sm-3 form-group" :class="{error: validation.hasError('formInput.from_date')}">
          <label>Date</label><span class="message">{{ validation.firstError('formInput.from_date') }}</span>
          <date-picker :disabled-date="disabledDates" input-class="form-control" ref="market_date" value-type="format" v-model="formInput.from_date" format='DD-MM-YYYY' readonly></date-picker>
        </div>

        <div class="col-sm-12" style="">
            <button type="button" v-on:click="addMarginRate" class="btn btn-lg btn-info pull-right mb-2">Submit</button>     
        </div>  

      <b-modal ref="default-margin-rate" title="Change Default Margin Rate" size="sm" hide-footer>
          <div class="form-group" :class="{error: validation.hasError('formInput.rate'),'col-sm-3':(type=='account'),'col-sm-6':(type!='account')}">
            <label>Margin Rate</label><span class="message">{{ validation.firstError('formInput.rate') }}</span>
            <input type="text" placeholder="Enter Margin Rate Here.." class="form-control" v-model="formInput.rate">
          </div>
          <div class="col-sm-12" style="">
            <button type="button" v-on:click="addMarginRate" class="btn btn-lg btn-info pull-right mb-2">Submit</button>     
          </div>  
      </b-modal>
        
      <TableView :col="columns" :getData="getData" v-if="ShowDefaultMarginRate"/>

      <h6 style="margin-top:-25px;" v-if="type=='account'">* If there is no value for the specified date, the margin value of the previous available date will be taken to calculate the statement.</br>* If there is no previous value or no entry for the account number, the default margin rate will be considered. </h6>
      <h6 style="color:red" v-if="type=='account'">* Attempting to change previous entries will conflict with the previous statement.</h6>
      <h6 style="margin-top:-25px;color:red" v-if="type=='default'">* This is for future uploads only, does not affect previous data.</h6>
      
      <b-modal ref="upload-deal-ticket-out" title="Upload Account(s) Margin Rate" size="xl" hide-footer v-if="can_access('marketvalue','upload') && type=='account'">
        <p class="my-4"><UploadDealTicketForm @forceRerender="uploadMarketValueFormReRender" uri="import_accounts_margin_rate" sample_file="accounts_marginrate_sample" note="" :check_verified="false"/></p>
      </b-modal>
  </div>
</template>

<script>
import common from '@/assets/js/common.js';
import moment from 'moment';
import SimpleVueValidator from 'simple-vue-validator';

const Validator = SimpleVueValidator.Validator;
export default {
  name: 'MarginRatePage',
  props: ['type'],
  components: {   },
  components: {
    TableView : () => import('@/components/Common/DataTable/Table') ,
    DatePicker : () => import('vue2-datepicker') ,
    Widget : () => import('@/components/Widget/Widget') ,
    VueBootstrapTypeahead : () => import('vue-bootstrap-typeahead'),
    UploadDealTicketForm : () => import('@/components/Accounts/UploadTradesCSV')
  },
  mixins: [common,SimpleVueValidator.mixin],
  data() {
    return {
      showAddDefaultMarginRate: 1,
      ShowDefaultMarginRate: 1,
      customers: [],
      instruments: [],
      default_margin_rate: [0],
      tidm: '',
      formInput:{
        'id': '',
        'status': 1,
        'rate' : '100',
        'account_number' : '',
        'lse_id' : '',
        'from_date': (this.type == 'account' ? moment().format('DD-MM-YYYY') : null)
      },
      columns: (() => {
        const cols = [
          { title: 'Account Number', visible: (this.type=='account'), field: 'account_number', thComp: 'FilterTh' },
          { title: 'Stock Name', field: 'tidm', thComp: 'FilterTh'},
          { title: 'Margin Rate', field: 'rate' },
          { title: 'Date', field: 'from_date', visible: (this.type=='account') },
          { title: 'Operation', tdComp: 'marginOpt', visible: this.can_access('marketvalue','modify') }
        ]
        const groupsDef = {
          Normal: [],
          Sortable: [],
          Extra: ['Operation']
        }
        return cols.map(col => {
          Object.keys(groupsDef).forEach(groupName => {
            if (groupsDef[groupName].includes(col.title)) {
              col.group = groupName
            }
          })
          return col
        })
      })(),
    };
  },
  validators: {
    'formInput.rate': function(value) {
      return Validator.value(value).required();
    },
    'formInput.account_number': function(value) {
      var valid_value = Validator.value(value);
      return this.type=='account' ? valid_value.required() : valid_value;
    },
    'tidm': function(value) {
      return Validator.value(value);
    },
    'formInput.from_date': function(value) {
      var valid_value = Validator.value(value);
      return this.type=='account' ? valid_value.required() : valid_value;
    }
  },
  watch: {
    'formInput.account_number': function (input) {
        if(this.$refs.account_number && input){
            this.getCustomer(input);
        }else{
            this.formInput.account_number = '';
        }
    },
    'tidm': function (input) {
        if(this.$refs.tidm && input){
            this.$refs.tidm.inputValue = input;
            this.getInstrumentByTicker(input);
        }else{
            this.formInput.lse_id = '';
        }
    },
  },
  methods: {
    async getCustomer(input) {
        const limit = 10, offset = 0, sort = '', order = '';
        var filter = {'approved_at':{from_date:'2020-01-01'}}; 
        filter['account_number'] = input;
        let uri = 'customer_list?limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter);
        const {response} = await this.call_axios(uri);
        this.customers = response.data?response.data.result:[];
    },
    setCustomerInfo (group,index) {
        this.$refs["account_number"].inputValue = group.account_number;
        this.formInput.account_number = group.account_number;
        // access the autocomplete component methods from the parent
        //this.$refs.account_number.clear()
    },
    customerFormattedDisplay (result) {
        return result.account_number+" ( "+result.firstname+""+(result.lastname?" "+result.lastname:"")+" )";
    },
    addMarginRate: function(){
      this.$validate()
          .then(async (success) => {
            if (success) {
              this.$refs['default-margin-rate'].hide();
              const {response} = await this.call_axios('default_margin_rate', 'post', this.formInput);
              this.ShowDefaultMarginRate = false;
              this.$nextTick(() => {
                  this.formInput.rate = 100;
                  this.ShowDefaultMarginRate = true;
              })
            }
          });
    },
    async getInstrumentByTicker (input) {
      const limit = 10, offset = 0, sort = '', order = '';
      var filter = {}; 
      filter['tidm'] = input;
      var uri = 'stock_list?limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter);
      const {response} = await this.call_axios(uri);
      this.instruments = response.data.result;
    },
    setInstrumentInfo (group) {
      if(typeof group == "object"){
        this.group = group;
        this.formInput.lse_id = group.id;
      }
    },
    InstrumentFormattedDisplay (result) {
      return result.tidm;
    },
    async getData(query, filter) {
      const { limit = 10, offset = 0, sort = '', order = '' } = JSON.parse(JSON.stringify(query));

      this.columns.forEach(col => {
        if (query[col.field]) {
          filter[col.field] = query[col.field];
        }else if(typeof filter[col.field] != 'undefined'){
          delete filter[col.field];
        }
      });

      let uri = 'default_margin_rate?limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter)+'&type='+this.type;
      var res = await this.call_axios(uri);
      if(this.type == 'default')
      this.default_margin_rate = res.response.data.result.splice(0, 1);
      return res;
    },
    disabledDates(date){
      if(moment(date).isAfter(moment())) return true;
      return false;
    },
    showModal(model) {
      this.$refs[model].show()
    },
    uploadMarketValueFormReRender(response){
      if(response.code==0){
          this.$refs['upload-deal-ticket-out'].hide()
          this.refreshView = true;
          this.$nextTick(function(){
            this.refreshView = false;
          });
      }
    },
  },
  created() {
    
  },
};
</script>
<style>
.vbt-autcomplete-list{
    z-index: 10000 !important;
}
</style>